import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import PortalTextBox from '../../portal/portalTextBox';

@inject('translationsStore') @observer
export default class EditTeamDialog extends Component {

    render(){

        const customContentStyle = {
            width: '475px'
        };

        const title = <DialogHeader 
                        title={this.props.translationsStore.translate('RENAME_TEAM')}
                        closeClick={this.props.onCancel}
                        displayCloseButton
                    />;
        return(
                <Dialog
                    title={title}
                    modal={false}
                    className='portal-confirm-dialog'
                    contentStyle={customContentStyle}
                    bodyClassName='portal-confirm-dialog-body475px'
                    open={this.props.open}>
                    <div
                        data-cy='add-team-dialog'
                        className='add-item-dialog-wrapper'
                    >
                        <form onSubmit={this.props.onSave}>
                            <div className='input-wrapper'>
                                <PortalTextBox 
                                    dataCy='rename-team-textfield'
                                    hintText={this.props.translationsStore.translate('TEAM_NAME')}
                                    floatingLabelText={this.props.translationsStore.translate('TEAM_NAME')}
                                    onChange={this.props.onChange}
                                    type='text'
                                    width='100%'
                                    value={this.props.teamName || ''}
                                />
                            </div>
                            <div className='buttons-wrapper'>
                                <span
                                    data-cy='team-edit-cancel-button'
                                    className='portal-blank-button'
                                    onClick={this.props.onCancel}
                                >
                                    {this.props.translationsStore.translate('CANCEL')}
                                </span>
                                <Button 
                                    dataCy='rename-team-button'
                                    type='submit'
                                    disabled={!this.props.teamName || this.props.teamName.trim() === ''}
                                    inProgress={this.props.inProgress}
                                    text={this.props.translationsStore.translate('SAVE')}
                                >
                                </Button>
                            </div>
                        </form>
                    </div>
                </Dialog>
        );
    }
}